/**
 * Styles for the border of an outlined TextField element.
 */
const CustomTextFieldOutlined = (custom = {}) => ({
  ...custom,
  "& .MuiOutlinedInput-root": {
    "& > fieldset": { borderColor: "#e7ebf8" },
  },
  "& .MuiInputLabel-root": {
    lineHeight: "1rem",
    fontSize: "0.8rem",
  },
  "& .MuiOutlinedInput-input": {
    padding: "5px",
  },
});

/**
 * Styles for the border of a solid color TextField element.
 */
const CustomTextFieldSolid = (custom = {}) => ({
  ...custom,
  "& .MuiOutlinedInput-root": {
    "& > fieldset": { border: "none" },
  },
  "& .MuiInputLabel-root": {
    lineHeight: "16px",
    fontSize: "16px",
  },
  "&.Mui-disabled": {
    backgroundColor: "#E5E9ED",
  },
});

/**
 * Styles for a TextField element.
 */
const CustomTextFieldOutlinedInputProps = {
  backgroundColor: "#E5E9ED",
  color: "#202338",
  borderRadius: "4px",
  height: "40px",
};

/**
 * Styles for a Select element.
 */
const CustomSelectProps = () => ({
  backgroundColor: "#20233810",
  color: "#202338",
  borderRadius: "4px",
  height: "40px",
});

/**
 * Styles for a modal's cancel Button.
 */
const ModalCustomCancel = () => ({
  color: "#000",
  backgroundColor: "#FFF",
  border: "1px solid #000",
  height: "40px",
  minWidth: "100px",
  fontSize: "16px",
  padding: "0px 20px",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#EBEBEB",
    border: "1px solid #000",
  },
  "&.Mui-disabled": {
    border: "1px solid #00000043",
    borderRadius: "4px",
    color: "#00000043",
  },
  "&.MuiButton-root": {
    textTransform: "capitalize",
  },
});

/**
 * Styles for a modal's Button.
 */
const ModalCustomDark = () => ({
  color: "#FFF",
  backgroundColor: "#000",
  border: "none",
  height: "40px",
  minWidth: "100px",
  fontSize: "16px",
  padding: "0px 20px",
  borderRadius: "4px",
  "&:hover": {
    color: "#5B6D7A",
    backgroundColor: "#000",
  },
  "&.Mui-disabled": {
    border: "none",
    borderRadius: "4px",
    color: "#FFF",
    backgroundColor: "#5B6D7A70",
  },
  "&.MuiButton-root": {
    textTransform: "capitalize",
  },
});

/**
 * Styles for a modal's confirm Button.
 */
const ModalCustomConfirm = () => ({
  color: "#FFF",
  backgroundColor: "#E2772E",
  border: "none",
  height: "40px",
  minWidth: "100px",
  fontSize: "16px",
  padding: "0px 20px",
  borderRadius: "4px",
  "&:hover": {
    color: "#FFF",
    backgroundColor: "#CE631A",
    border: "none",
  },
  "&.Mui-disabled": {
    color: "#FFF",
    backgroundColor: "#E2772E43",
    border: "none",
  },
  "&.MuiButton-root": {
    textTransform: "capitalize",
  },
});

/**
 * Styles for a modal's confirm Button (dark variant).
 */
const ModalCustomConfirmDark = () => ({
  color: "#FFF",
  backgroundColor: "#202338",
  border: "none",
  height: "40px",
  minWidth: "100px",
  fontSize: "16px",
  padding: "0px 20px",
  borderRadius: "4px",
  "&:hover": {
    color: "#FFF",
    backgroundColor: "#0C0F24",
    border: "none",
  },
  "&.Mui-disabled": {
    color: "#FFF",
    backgroundColor: "#20233843",
    border: "none",
  },
  "&.MuiButton-root": {
    textTransform: "capitalize",
  },
});

/**
 * Styles for a modal's warning Button.
 */
const ModalCustomWarning = () => ({
  color: "#000",
  backgroundColor: "#E7C43C",
  border: "none",
  height: "40px",
  minWidth: "100px",
  fontSize: "16px",
  padding: "0px 20px",
  borderRadius: "4px",
  "&:hover": {
    color: "#000",
    backgroundColor: "#D3B028",
    border: "none",
  },
  "&.Mui-disabled": {
    color: "#000",
    backgroundColor: "#E7C43C43",
    border: "none",
  },
  "&.MuiButton-root": {
    textTransform: "capitalize",
  },
});

/**
 * Styles for a modal's confirm Button.
 */
const ModalCustomSwitch = () => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#E2772E",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#E2772E",
  },
});

/**
 * Used to apply a some default styling to the page wrapper container.
 */
const PageContainerWrapper = (custom = { minHeight: "100%", flexGrow: 1 }) => ({
  ...custom,
  overflow: "hidden",
  display: "block",
  position: "relative",
});

const CustomIconButtonDark = () => ({
  borderRadius: "4px",
  color: "#FFF",
  backgroundColor: "#202338",
  "&:hover": {
    color: "#FFF",
    backgroundColor: "#0C0F24",
  },
  "&:disabled": {
    color: "#FFF",
    backgroundColor: "#20233843",
  },
});

const CustomIconButtonGray = () => ({
  borderRadius: "4px",
  color: "#FFF",
  backgroundColor: "#5B6D7A",
  "&:hover": {
    color: "#FFF",
    backgroundColor: "#475966",
  },
  "&:disabled": {
    color: "#FFF",
    backgroundColor: "#5B6D7A43",
  },
});

export {
  CustomTextFieldSolid,
  CustomTextFieldOutlined,
  CustomTextFieldOutlinedInputProps,
  CustomSelectProps,
  ModalCustomDark,
  ModalCustomCancel,
  ModalCustomWarning,
  ModalCustomConfirm,
  ModalCustomConfirmDark,
  PageContainerWrapper,
  ModalCustomSwitch,
  CustomIconButtonDark,
  CustomIconButtonGray,
};
